import { Component } from "react";
import ErrorFilterbarLayout from "./layouts/filterbar";
import ErrorPageLayout from "./layouts/page";

interface IProps {
  fallback: React.ReactNode;
}

export class ErrorBoundary extends Component<IProps> {
  state = { error: null };

  static defaultProps: IProps = {
    fallback: [],
  };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  render() {
    if (this.state.error) {
      return this.props.fallback;
    }
    return this.props.children;
  }
}

export const ErrorFilterbar = ErrorFilterbarLayout;
export const ErrorPage = ErrorPageLayout;
